import { render, staticRenderFns } from "./MelEdit.vue?vue&type=template&id=557bd8e2&scoped=true"
import script from "./MelEdit.vue?vue&type=script&lang=js"
export * from "./MelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557bd8e2",
  null
  
)

export default component.exports